import React from 'react';

import {RemoveIcon} from 'src/components/remove-icon';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';


type Props = {
    addedFile: File,
    removeFile: () => void,
};

export const AddedFile = ({addedFile, removeFile}: Props) => (
    <Group direction="v" gap="sm" alignItems="start">
        <strong>Uploaded</strong>
        <Group justify="space-between" alignItems="center">
            <Group alignItems="center">
                <Icon type={Icons.FILE}/>
                <div style={{maxWidth: 300}}>
                    <EllipsisTextHint title={addedFile.name}>
                        {addedFile.name}
                    </EllipsisTextHint>
                </div>
            </Group>
            <RemoveIcon handler={removeFile}/>
        </Group>
    </Group>
);
